export class StringSizes {
    static readonly small = 200;
    static readonly medium = 600;
    static readonly large = 1000;
}
export class KeyValuePair {
    /**
     * Creates a key value pair object. If value is left empty then
     * both key and value will be the same
     * @param key key
     * @param value if undefined the value of key will be used
     * @param selected selected or not
     */
    constructor(key: string | number | boolean, value?: string | number | boolean, selected?: boolean) {};
    key: string | number | boolean;
    value: string | number | boolean;
    selected: boolean;
}
export class AutocompleteGroup {
    constructor(label: string, options: KeyValuePair[]) {};
    label: string;
    options: KeyValuePair[];
}
// Commented line below and changed 'declare class' to 'export class' to resolve
// Webpack loader error.
//export { StringSizes, KeyValuePair, AutocompleteGroup };
